import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./index.scss";

import {
  addPopup,
  addToken,
  setDefaultToken,
  getUserData,
  deleteToken,
} from "../../../redux/actions";

import * as popups from "../../../constants/popup-types";
import * as routes from "../../../constants/routes";

//assets
import card from "assets/icons/payment-methods.svg";
import arrow from "assets/icons/arrow-black.svg";
import lock from "assets/icons/lock.svg";
import { getMediaPath } from "../../../app/functions";

const CreditCards = (props) => {
  //import redux state
  const text = useSelector((state) => state.config.Translations);
  const deviceState = useSelector((state) => state.state.deviceState);
  const user = useSelector((state) => state.config.UserData);
  let telecard_url = useSelector((state) => state.data.TelecardUrl);

  const isDesktop =
    deviceState === "desktop" || deviceState === "desktop-large";

  const [step, updateStep] = useState(1);

  const [newUrl, updateUrl] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener(
      "message",
      (e) => {
        if ( e.origin === window.location.origin || e.origin.endsWith("hot.co.il")  ) {
          const result = e.data;
          if (result.from !== "hot") return;
            if (result.status === "success") {
              dispatch(getUserData());
              setTimeout(() => {
                updateStep(1);
              }, 1000);
            } else {
              updateUrl(result.url);
              dispatch(
                addPopup({
                  type: popups.GENERAL_MESSAGE,
                  text: result.description,
                })
              );
            }
        }
      },
      false
    );
  }, []);

  let performDeleteAction = (tokenId) => {
    dispatch(deleteToken({ tokenId: tokenId }));
  };

  let handleRemoveClick = (item) => {
    dispatch(
      addPopup({
        type: popups.DELETE_CARD,
        credit_number: "(" + item.last_digits + ")",
        tokenId: item.id,
        holderName: user["first_name"] + " " + user["last_name"],
        deleteText: text["delete_card_btn"],
        title: text["delete_card_title"],
        action: () => performDeleteAction(item.id),
      })
    );
  };

  let handleAddCardClick = () => {
    updateStep(2);
    dispatch(addToken());
  };

  let handleSetCardAsDefault = (tokenId) => {
    dispatch(setDefaultToken({ tokenId: tokenId }));
  };

  let getCards = () => {
    const isDesktop =
      deviceState === "desktop" || deviceState === "desktop-large";

    let res = [];

    for (let key in user.cardsArr) {
      const item = user.cardsArr[key];
      const isDefault = item.default;
      if (item.active) {
        res.push(
          <div key={key} className="card-wrapper">
            <div className="card-name">
              {!isDesktop && <span>{item.title}</span>}
              <span>{"(" + item.last_digits + ")"}</span>
            </div>
            <span className="user-name">
              {user["first_name"] + " " + user["last_name"]}
            </span>
            <div className="default-card">
              {isDefault && (
                <span className="default-span">
                  {text["credit_cards_default"]}
                </span>
              )}
              {!isDefault && (
                <span
                  className="change-default"
                  onClick={() => handleSetCardAsDefault(item.id)}
                >
                  {text["credit_cards_default_change"]}
                </span>
              )}
            </div>

            <span className="remove" onClick={() => handleRemoveClick(item)}>
              {text["credit_cards_remove"]}
            </span>
          </div>
        );
      }
    }

    return res;
  };

  const handleBackClick = () => {
    if (step === 1) {
      props.history.push(routes.personal_zone);
    } else {
      updateStep(1);
    }
  };

  return (
    <div className="mobile-layout open">
      <div className="top payment">
        <div className="wrapper">
          <img
            src={isDesktop ? getMediaPath(card) : getMediaPath(arrow)}
            alt=""
            className="icon"
            onClick={handleBackClick}
          />
          <span className="title">{text["personal_zone_payment_methods"]}</span>
        </div>
        <span className="hot-cg-span">{text["hot_cg_span"]}</span>
        {isDesktop && (
          <div className="security-wrap">
            <img src={getMediaPath(lock)} alt="" />
            <span>האתר מאובטח</span>
          </div>
        )}
      </div>
      <section className={"credit-cards " + (step === 2 ? "form-mode" : "")}>
        {step === 1 && (
          <Fragment>
            {getCards()}
            {getCards().length < 1 && isDesktop && (
              <div className="no-content-placeholder">
                {text["no_cards_placeholder"]}
              </div>
            )}
            <button className="add-card-btn" onClick={handleAddCardClick}>
              {text["credit_cards_add"]}
            </button>
          </Fragment>
        )}
        {step === 2 && (
          <Fragment>
            {telecard_url && (
              <iframe
                className="tc-form"
                referrerPolicy="strict-origin-when-cross-origin"
                src={newUrl ? newUrl : telecard_url}
                title="cg-iframe"
              />
            )}
          </Fragment>
        )}
      </section>
    </div>
  );
};

export default CreditCards;
